import { ActionInputButton } from "src/components/ActionInputButton/ActionInputButton";
import { IconButtonMiniV2 } from "src/components/IconButtonMiniV2/IconButtonMiniV2";
import type { ButtonHTMLAttributes } from "react";

type Props = {
  isBound: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function BindButton({ isBound, ...rest }: Props) {
  return (
    <ActionInputButton type="button" {...rest}>
      <i className={isBound ? "icon-15-connect" : "icon-15-disconnect"} />
    </ActionInputButton>
  );
}

export function MiniBindButton({ isBound, color, ...rest }: Props) {
  return (
    <IconButtonMiniV2 type="button" {...rest}>
      <i className={isBound ? "icon-15-connect" : "icon-15-disconnect"} />
    </IconButtonMiniV2>
  );
}
